module.exports = __webpack_public_path__ + "static/creator-tokens-share-upside-cea987c231bc8a621c51bba2eaf34afe.webp";